module.exports = __webpack_public_path__ + "static/media/997933.eb56fe90.png";